
import { defineComponent } from "vue";
import { useStore } from "vuex";
import Checkbox from "@/components/shared/Checkbox.vue";
import GenericPanel from "../shared/GenericPanel.vue";
import GenericSubPanel from "../shared/GenericSubPanel.vue";
import GenericButton from "../shared/GenericButton.vue";

export default defineComponent({
  name: "Traits",
  components: {
    Checkbox,
    GenericPanel,
    GenericSubPanel,
    GenericButton,
  },
  setup() {
    const store = useStore();
    const showInfo = (category: string, stat: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "updateInfoPanel",
        data: { category, stat },
      });
    };
    const tagTrait = (trait: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "tagTrait",
        data: trait,
      });
    };
    const isTagged = (trait: string) => {
      return store.state.build.Traits[trait].tagged;
    };
    return {
      state: store.state,
      Traits: store.state.build.Traits,
      tagTrait,
      showInfo,
      isTagged,
    };
  },
});
